<template>
  <b-container>
    <div class="container-fluid">
      <b-row>
        <b-col>
          <h4 class="ml-3 mt-2">Providers</h4>
        </b-col>
      </b-row>
      <b-row class="mb-1 mr-1 ml-1">
        <b-col
          xs="12"
          sm="12"
          md="12"
          lg="4"
          xl="4"
          class="d-flex justify-content-center mt-1"
        >
        </b-col>

        <b-col xs="12" sm="12" md="12" lg="4" xl="4" class="mt-1"> </b-col>

        <b-col
          xs="12"
          sm="12"
          md="12"
          lg="4"
          xl="4"
          class="d-flex justify-content-end mt-1"
        >
          <b-button variant="success" @click="showModal()" class="mr-2">
            <b-icon icon="plus" class="mt-1" />
          </b-button>
          <b-button variant="outline-success" class="" @click="downloadXL()">
            <b-icon icon="file-spreadsheet"></b-icon> Download
          </b-button>
        </b-col>
      </b-row>
      <div class="pt-4">
        <div class="container-fluid">
          <b-table
            v-if="isFieldsReady"
            thead-class="text-center bg-light-grey "
            head-variant="light"
            bordered
            small
            show-empty
            outlined
            stacked="md"
            :fields="fields"
            :items="providers ? providers : []"
            id="tableMain"
            :busy="isLoadingProviders"
          >
            <template #empty>
              <div class="text-center">
                <h6>{{ $t("thereAreNoRecordsToShow") }}</h6>
              </div>
            </template>
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner variant="primary" class="align-middle"></b-spinner>
                <p>Loading</p>
              </div>
            </template>
            <template v-slot:cell(website)="{ item }">
              <a :href="item.website" target="_blank">
                {{ item.website }}
              </a>
            </template>
            <template v-slot:cell(info)="{ item }">
              <label v-if="item.manual == 1"> Manual</label>
              <label v-else-if="item.manual == 0"> API</label>
            </template>

            <template v-slot:cell(type)="{ item }">
              <label v-if="item.wholesale == 1"> Wholesale</label>
              <label v-if="item.wholesale == 0"> Retail</label>
            </template>
            <template v-slot:cell(price)="{ item }">
              {{ item.price | currency }}
            </template>
            <template
              v-for="field in dates"
              v-slot:[`cell(${field})`]="{ item }"
            >
              <span :key="field">
                {{ item[field] ? item[field].price : "-" | currency }}
                <b-icon
                  icon="pencil-fill"
                  class="cursor-pointer"
                  variant="info"
                  @click="editPrice(item, field)"
                ></b-icon>
              </span>

              <!-- 
                <b-button
                  size="sm"
                  variant="primary"
                >
                  Editar precio
                </b-button> -->
            </template>
            <template v-slot:cell(actions)="row">
              <div class="text-center">
                <b-form-group>
                  <b-icon
                    v-b-tooltip.hover
                    title="Details"
                    icon="eye"
                    class="h5 m-2"
                    @click="editItem(row.item)"
                  ></b-icon>
                  <b-icon
                    v-if="!isLoadingDeleteVehicle"
                    v-b-tooltip.hover
                    title="Delete"
                    icon="trash"
                    class="h5 m-2"
                    @click="deletePrice(row.item.id)"
                  ></b-icon>
                  <!-- loader -->
                  <b-spinner
                    v-if="isLoadingDeleteVehicle"
                    variant="primary"
                    class="align-middle"
                    small
                  ></b-spinner>
                </b-form-group>
              </div>
            </template>
          </b-table>
        </div>
      </div>

      <b-modal
        ref="providerPriceModal"
        id="providerPriceModal"
        size="lg"
        hide-footer
        body-class="pl-0 pr-0"
        ok-disabled
        @hidden="providerItem = {}"
      >
        <ProviderPriceForm
          :vehicleId="vehicleId"
          :refreshData="getData"
          :hideModal="hideModal"
          :providerItem="providerItem"
        />
      </b-modal>
    </div>
  </b-container>
</template>
<script>
import ProviderPriceForm from "./ProviderPriceForm.vue";

import { mapState } from "vuex";
import {
  GET_VEHICLES_PROVIDER_PRICE_BY_ID,
  DELETE_VEHICLE_PROVIDER_PRICE,
} from "./actions";
import { generalMixin } from "@/modules/mixin.js";
export default {
  name: "ProvidersPriceTable",
  components: { ProviderPriceForm },
  mixins: [generalMixin],
  props: {
    vehicleId: {
      type: Number,
      required: true,
    },
    dateFrom: {
      type: String,
      default: "",
    },
    dateTo: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState({
      providers: (state) =>
        state.adminStore.vehiclesProviderPrice.vehiclePricesList.data,
      dates: (state) =>
        state.adminStore.vehiclesProviderPrice.vehiclePricesList.dates,
      isLoadingProviders: (state) =>
        state.adminStore.vehiclesProviderPrice.vehiclePricesList.status ==
        "fetching",
      isLoadingDeleteVehicle: (state) =>
        state.adminStore.vehiclesProviderPrice.vehiclePrice.status ==
        "fetching",
    }),
  },
  data() {
    return {
      providerItem: {},
      filter: "",
      fields: [{ key: "name", label: "Provider", class: "text-center" }],
      isFieldsReady: false,
      dates: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.isFieldsReady = false;
      console.log("Fetching vehicle prices for ID:", this.vehicleId);
      this.$store
        .dispatch(GET_VEHICLES_PROVIDER_PRICE_BY_ID, {
          id: this.vehicleId,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        })
        .then((response) => {
          this.dates = response.dates;
          this.formatFields(response.dates);
        });
    },
    formatFields(dates) {
      console.log("Formatting fields with dates:", dates);
      dates.forEach((date) => {
        this.fields.push({
          key: date,
          label: date,
          class: "text-center",
          formatter: (price) => this.$options.filters.currency(price.price),
        });
      });
      this.isFieldsReady = true;
    },

    async activateItem(item) {
      const payload = {
        id: item.id,
        status: 1,
      };
      this.$store
        .dispatch("PUT_USER_BUYER", payload)
        .then(() => {
          this.makeToast("Success", "Provider updated successfully", "success");
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast(this.user.error.response.data.message, {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    deletePrice(id) {
      const payload = {
        id: id,
        status: 0,
      };
      this.$store
        .dispatch(DELETE_VEHICLE_PROVIDER_PRICE, payload)
        .then(() => {
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },
    showModal() {
      this.$bvModal.show("providerPriceModal");
    },
    editItem(item) {
      console.log(item);
      this.providerItem = item;
      this.$bvModal.show("providerPriceModal");
    },
    editPrice(item, field) {
      this.providerItem = {
        id: item[field].id,
        supplierId: item[field].suppliers_id,
        price: item[field].price,
        date: item[field].date,
        vehicleId: item[field].vehicles_id,
      };

      this.$bvModal.show("providerPriceModal");
    },

    hideModal() {
      this.$bvModal.hide("providerPriceModal");
    },
    downloadXL() {
      this.$emit("download-providers-excel");
    },
  },
};
</script>
